import React, { useState, useImperativeHandle, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Tabs, Tab } from '@mui/material'
import { Colors } from 'Theme'
import { IFTabs } from 'Components'
import OperatorUserPageTabsSkeleton from './OperatorUserPageTabsSkeleton'
import { useTranslation } from 'react-i18next'

const OperatorUserPageTabs = React.forwardRef(
  (
    {
      onValueChange,
      isLoading,
      initialIndex,
      OperatorUsersCount,
      fetchListRequestState,
      InvitationCount,
    },
    ref,
  ) => {
    const { t } = useTranslation()

    const tabTitles = {
      OperatorUsers: t('OperatorUserPageContainer.OperatorUsersTab'),
      Invitations: t('OperatorUserPageContainer.InviteTab'),
    }
    const [selectedIndex, setSelectedIndex] = useState(initialIndex)
    useEffect(() => {
      setSelectedIndex(initialIndex)
    }, [initialIndex])
    const handleChange = (event, newValue) => {
      setSelectedIndex(newValue)
      onValueChange(newValue)
    }

    const resetIndex = () => {
      setSelectedIndex(0)
    }

    useImperativeHandle(ref, () => ({
      resetIndex,
    }))

    return (
      <div>
        {isLoading ? (
          <OperatorUserPageTabsSkeleton
            tabsCount={Object.keys(tabTitles).length}
          />
        ) : (
          <Tabs
            value={selectedIndex}
            onChange={handleChange}
            TabIndicatorProps={{
              style: {
                backgroundColor: Colors.primary,
              },
            }}
          >
            {Object.entries(tabTitles).map(([key, title], index) => (
              <Tab
                sx={{
                  padding: '0px',
                  minWidth: 'fit-content',
                  maxWidth: 'fit-content',
                }}
                key={index}
                label={
                  <IFTabs
                    title={title}
                    isSelected={selectedIndex === index}
                    fetchListRequestState={fetchListRequestState}
                    count={
                      key === 'OperatorUsers'
                        ? OperatorUsersCount
                        : InvitationCount
                    }
                  />
                }
              />
            ))}
          </Tabs>
        )}
      </div>
    )
  },
)

OperatorUserPageTabs.propTypes = {
  onValueChange: PropTypes.func.isRequired,
  initialIndex: PropTypes.number,
  OperatorUsersCount: PropTypes.number,
  RoleCount: PropTypes.number,
  InvitationCount: PropTypes.number,
  isLoading: PropTypes.bool,
}

export default OperatorUserPageTabs
